import { TRACKED_EVENT_POSITION } from '@/constants/gtag';

// TODO: 10주년 전용 position 확정 전 임시값 — 사이트 GNB·푸터·본문과 GA 집계가 섞인다.
// 확정되면 gtag.ts 에 값을 추가하고 여기만 바꾼 뒤 docs/ga/catalog.tsv 에 등록한다
export const TEN_YEARS_POSITION = {
  GNB: TRACKED_EVENT_POSITION.NAV,
  FOOTER: TRACKED_EVENT_POSITION.FOOTER,
  NOT_FOUND: TRACKED_EVENT_POSITION.MAIN_CONTENT,
} as const;
